export default "__VITE_ASSET__DurPu_FF__"